import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { IConfigAddPayload, IConfigUpdatePayload } from './config.interface';

@Injectable({
    providedIn: 'root',
})
export class ConfigService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;
    private getConfigDTUrl =
        this.basePath +
        environment.interop.dgitl.settings.configurations.getConfigurationsDT;
    private storeConfigUrl =
        this.basePath +
        environment.interop.dgitl.settings.configurations.storeConfiguration;
    private updateConfigUrl =
        this.basePath +
        environment.interop.dgitl.settings.configurations.putConfiguration;

    private deleteConfigURL =   
        this.basePath +
        environment.interop.dgitl.settings.configurations.deleteConfiguration;

    constructor(private http: HttpClient) { }

    getConfigDT() {
        return this.http.get(this.getConfigDTUrl, this.httpOptions);
    }

    addConfig(data: IConfigAddPayload) {
        return this.http.post(this.storeConfigUrl, data, this.httpOptions);
    }

    updateConfig(data: IConfigUpdatePayload) {
        return this.http.put(this.updateConfigUrl, data, this.httpOptions);
    }

    deleteConfig(id: number) {
		return this.http.delete(this.deleteConfigURL + id);
	}


    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
